import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import Home from './pages/Home';
import Plans from './pages/Plans';
import Success from './pages/Success';
import Privacy from './pages/Privacy';
import HowItWorks from './pages/HowItWorks';
import XtreamRenewal from './pages/XtreamRenewal';
import AdminLogin from './pages/AdminLogin';
import AdminChannels from './pages/AdminChannels';
import AdminHome from './pages/AdminHome';
import AdminTestTokens from './pages/AdminTestTokens';
import AdminUsers from './pages/AdminUsers';
import AdminRevenue from './pages/AdminRevenue';
import AdminXtream from './pages/AdminXtream';
import AdminPromoCodes from './pages/AdminPromoCodes';
import AdminWhatsApp from './pages/AdminWhatsApp';
import AdminResellers from './pages/AdminResellers';
import AdminWithdrawals from './pages/AdminWithdrawals';
import AdminProxyConfig from './pages/AdminProxyConfig';
import AdminLiveCdn from './pages/AdminLiveCdn';
import AdminNotification from './pages/AdminNotification';
import AdminCreditManagement from './pages/AdminCreditManagement';
import AdminPricing from './pages/AdminPricing';
import AdminCategoryBlock from './pages/AdminCategoryBlock';
import AdminResellerSettings from './pages/AdminResellerSettings';
import AdminMacActivation from './pages/AdminMacActivation';
import AdminAppActivations from './pages/AdminAppActivations';
import AdminBotApiKeys from './pages/AdminBotApiKeys';
import AdminMediaMtx from './pages/AdminMediaMtx';
import AdminPaymentAggregators from './pages/AdminPaymentAggregators';
import ResellerLogin from './pages/ResellerLogin';
import ResellerDashboard from './pages/ResellerDashboard';
import ResellerPage from './pages/ResellerPage';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ProtectedRoute from './components/ProtectedRoute';
import './styles/GlobalDesign.css';

function RestoreAdminRoute() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const isStandalone = window.matchMedia?.('(display-mode: standalone)').matches || window.navigator.standalone;
    const savedPath = localStorage.getItem('adminLastPath');
    const user = (() => {
      try {
        return JSON.parse(localStorage.getItem('user') || 'null');
      } catch (_) {
        return null;
      }
    })();

    if (isStandalone && location.pathname === '/' && localStorage.getItem('token') && user?.role === 'admin'
      && savedPath?.startsWith('/admin/') && savedPath !== '/admin/login') {
      navigate(savedPath, { replace: true });
    }
  }, [location.pathname, navigate]);

  return null;
}

function App() {
  return (
    <Router>
      <div className="App">
        <RestoreAdminRoute />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/plans" element={<Plans />} />
          <Route path="/success" element={<Success />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/channels" element={<ProtectedRoute><AdminChannels /></ProtectedRoute>} />
          <Route path="/admin/home" element={<ProtectedRoute><AdminHome /></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute><AdminUsers /></ProtectedRoute>} />
          <Route path="/admin/revenue" element={<ProtectedRoute><AdminRevenue /></ProtectedRoute>} />
          <Route path="/admin/receipts" element={<ProtectedRoute><AdminRevenue receiptsOnly /></ProtectedRoute>} />
          <Route path="/admin/test-tokens" element={<ProtectedRoute><AdminTestTokens /></ProtectedRoute>} />
          <Route path="/admin/xtream" element={<ProtectedRoute><AdminXtream /></ProtectedRoute>} />
          <Route path="/admin/mac" element={<ProtectedRoute><AdminMacActivation /></ProtectedRoute>} />
          <Route path="/admin/app-activations" element={<ProtectedRoute><AdminAppActivations /></ProtectedRoute>} />
          <Route path="/admin/bot-api-keys" element={<ProtectedRoute><AdminBotApiKeys /></ProtectedRoute>} />
          <Route path="/admin/promo-codes" element={<ProtectedRoute><AdminPromoCodes /></ProtectedRoute>} />
          <Route path="/admin/whatsapp" element={<ProtectedRoute><AdminWhatsApp /></ProtectedRoute>} />
          <Route path="/admin/resellers" element={<ProtectedRoute><AdminResellers /></ProtectedRoute>} />
          <Route path="/admin/withdrawals" element={<ProtectedRoute><AdminWithdrawals /></ProtectedRoute>} />
          <Route path="/admin/credit" element={<ProtectedRoute><AdminCreditManagement /></ProtectedRoute>} />
          <Route path="/admin/proxy-config" element={<ProtectedRoute><AdminProxyConfig /></ProtectedRoute>} />
          <Route path="/admin/live-cdn" element={<ProtectedRoute><AdminLiveCdn /></ProtectedRoute>} />
          <Route path="/admin/mediamtx" element={<ProtectedRoute><AdminMediaMtx /></ProtectedRoute>} />
          <Route path="/admin/notifications" element={<ProtectedRoute><AdminNotification /></ProtectedRoute>} />
          <Route path="/admin/pricing" element={<ProtectedRoute><AdminPricing /></ProtectedRoute>} />
          <Route path="/admin/category-block" element={<ProtectedRoute><AdminCategoryBlock /></ProtectedRoute>} />
          <Route path="/admin/reseller-settings" element={<ProtectedRoute><AdminResellerSettings /></ProtectedRoute>} />
          <Route path="/admin/payment-aggregators" element={<ProtectedRoute><AdminPaymentAggregators /></ProtectedRoute>} />
          
          {/* Reseller Routes */}
          <Route path="/reseller/login" element={<ResellerLogin />} />
          <Route path="/reseller/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/reseller/dashboard" element={<ResellerDashboard />} />
          <Route path="/reseller/:slug" element={<ResellerPage />} />
          <Route path="/renew/:token" element={<XtreamRenewal />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
